var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCheckLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#11BE36",
    d: "M20 2.5C29.664984 2.5 37.5 10.335017 37.5 20C37.5 29.664984 29.664984 37.5 20 37.5C10.335017 37.5 2.5 29.664984 2.5 20C2.5 10.335017 10.335017 2.5 20 2.5ZM20 40C31.045694 40 40 31.045694 40 20C40 8.9543047 31.045694 0 20 0C8.9543047 0 0 8.9543047 0 20C0 31.045694 8.9543047 40 20 40ZM28.382812 15.882812C28.867188 15.398438 28.867188 14.601562 28.382812 14.117188C27.898438 13.632812 27.101562 13.632812 26.617188 14.117188L17.5 23.234375L13.382812 19.117188C12.898438 18.632812 12.101562 18.632812 11.617188 19.117188C11.132812 19.601562 11.132812 20.398438 11.617188 20.882812L16.617188 25.882812C17.101562 26.367188 17.898438 26.367188 18.382812 25.882812L28.382812 15.882812Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckLight);
export default __webpack_public_path__ + "static/media/circle-check-light.2e3cc3cd9bc8a581be0b04fcc6d00f74.svg";
export { ForwardRef as ReactComponent };